import { Core, PRIVACY_NOTICE, ACCESS_TOKEN } from '@services/Core';
import { AxiosPromise } from 'axios';
import { IDataSubjectRightLookups } from '@interfaces/DataSubjectRightLookups.interface';
import { DataSubjectRightResponse } from '@interfaces/DataSubjectRight.interface';

const DSR_REQUEST_TOKEN = process.env.REACT_APP_DSR_REQUEST_TOKEN;
interface GetAccessToken {
  (): AxiosPromise<{ access_token: string }>;
}

interface SubmitDataSubjectRightForm {
  (data: FormData, token: string): AxiosPromise<DataSubjectRightResponse>;
}

interface VerifyOtp {
  (data: { otp: string; requestId: string }, token: string): AxiosPromise<{
    jiraTicketId: 'TT-1234';
  }>;
}

interface GetDataSubjectLookups {
  (token: string): AxiosPromise<IDataSubjectRightLookups>;
}

class DataSubjectRight extends Core {
  getAccessToken: GetAccessToken = async () => {
    const formData = new URLSearchParams();
    formData.append('grant_type', 'client_credentials');
    return this.post(`${ACCESS_TOKEN}`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Basic ${DSR_REQUEST_TOKEN}`,
      },
      transformRequest: [
        (data, headers) => {
          headers['Content-Type'] = 'application/x-www-form-urlencoded';
          return data;
        },
      ],
    });
  };
  getDataSubjectLookups: GetDataSubjectLookups = async (token) =>
    this.get(`${PRIVACY_NOTICE}/subject/right/lookup`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  submitDataSubjectRightForm: SubmitDataSubjectRightForm = async (data, token) =>
    this.post(`${PRIVACY_NOTICE}/subject/right`, data, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
    });
  verifyOtp: VerifyOtp = async (data, token) =>
    this.post(`${PRIVACY_NOTICE}/otp/verify`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
}

export const dataSubjectRight = new DataSubjectRight();
